import { render, staticRenderFns } from "./ChildrenUser.vue?vue&type=template&id=34a075e4&scoped=true"
import script from "./ChildrenUser.vue?vue&type=script&lang=js"
export * from "./ChildrenUser.vue?vue&type=script&lang=js"
import style0 from "./ChildrenUser.vue?vue&type=style&index=0&id=34a075e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a075e4",
  null
  
)

export default component.exports